import RequestHandler from "./request-handler";
class CustomerIdMapService {
    constructor() {
        this.path = "CustomerIdMap";
        if (CustomerIdMapService.instance) {
            return CustomerIdMapService.instance;
        }
        CustomerIdMapService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async import(data) {
        return await RequestHandler.import(this.path, data);
    }
}
const instance = new CustomerIdMapService();
export default instance;